import React, { useState, useEffect, useContext } from 'react';
import UpgardeContent from '../../Shared/Subscription/UpgradeContent';
import {
    cloneProject,
    deleteProjectFromDesigner,
    getProject,
    updateProjectPropertiesAfterPublish
} from '../../../API/Project/project';
import { bindShuffleMessageI18nEvents, messages } from '../../Shared/ShuffleMessage/MessagesHelper';
import { getCompressedJson } from '../../../API/Export/ExportApi';
import { publishApplication } from '../../Helpers/Launch';
import { MsalContext } from '@azure/msal-react';
import { InProgressPublishContent } from '../../PublishToRuntime/InProgressPublish';
import { FailurePublishContent } from "../../PublishToRuntime/FailurePublish";
import { SuccessfulPublishContent } from '../../PublishToRuntime/SuccessfulPublish';
import {
    validateForPublish,
    checkProjectForDisplayPages,
    performIncrementalGeneration,
    performFullGeneration
} from '../../../API/Generation/Generation';
import { isAccessedInIframe } from '../../Helpers/Iframe/iframe';
import { postMessageToRuntime } from '../../Helpers/Runtime/runtime';
import { getAzureUser } from '../../../API/User/User';
import { deleteDirectory } from '../../Helpers/DateLakeStorage';

const PublishingAppToWorkspace = (props) => {
    const { user, organization, selectedApp, onCancel, onCreate, openedInRuntime } = props;
    const msalContext = useContext(MsalContext);
    const [appStatus, setAppStatus] = useState("");
    const [error, setError] = useState({ isValid: true, message: "" });

    useEffect(() => {
        const publishWorkflow = async () => {
            bindShuffleMessageI18nEvents();
            try {
                console.time("Designer");
                let project = await getProject(selectedApp._id);
                const instanceId = selectedApp.masterAppId || selectedApp.instances.find(instance => instance.instanceType === "Production")._id || selectedApp.instances[0]._id;
                let response = await cloneProject(project, organization, selectedApp.organizationId, false, instanceId, false);
                if (response.status === "success") {
                    try {
                        const validationResult = await validateForPublish(response.data._id, "Production");
                        if (validationResult.error) {
                            throw { message: validationResult.error, isValid: false };
                        } else {
                            const publishResult = await publishProject(response.data);
                            if (publishResult.status === "Failure") {
                                throw publishResult;
                            }
                        }
                    } catch (err) {
                        await deleteProjectFromDesigner(response.data._id);
                        let path = organization._id + "/" + response.data._id;
                        deleteDirectory(path, response.data._id);
                        setAppStatus("Failure");
                        setError({ isValid: false, message: err.message });
                    }
                } else {
                    if (response.type === "upgrade") {
                        setAppStatus("Upgrade");
                        return;
                    }
                    setAppStatus("Failure");
                    setError(response.error);
                }
            } catch (error) {
                setAppStatus("Failure");
                setError({ isValid: false, message: error.message });
            }
        };

        publishWorkflow();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedApp, organization]);

    const publishProject = async (dataItem) => {
        const azureUser = await getAzureUser(msalContext);
        const userId = azureUser.oid;
        const { _id: organizationId } = organization;
        const instance = dataItem.instances.find(instance => instance.instanceType === "Production");
        const projectHasDisplayPages = await checkProjectForDisplayPages(dataItem._id);
        let compressedJson;
        if (projectHasDisplayPages) {
            compressedJson = await performIncrementalGeneration(dataItem._id, organizationId, userId, instance._id);
        } else {
            await performFullGeneration(dataItem._id);
            compressedJson = await getCompressedJson(
                dataItem._id,
                organizationId,
                user.azureId,
                instance._id,
                false,
                false
            );
        }
        console.timeEnd("Designer");
        let response = await publishJsonToRuntime(compressedJson, instance);
        if (response.status === "Success") {
            await updateProjectPropertiesAfterPublish(dataItem._id, instance._id);
        } else {
            return response
        }
        if (onCreate) {
            onCreate(dataItem);
        }
        setAppStatus("Success");
        if (openedInRuntime) {
            if (isAccessedInIframe()) {
                let url = response.data.appUrl + "/" + (dataItem.defaultPortal && dataItem.defaultPortal.id ? dataItem.defaultPortal.urlName : "");
                postMessageToRuntime({
                    type: "projectCreated",
                    openAppUrl: url
                });
            }
            return { status: "Success" };
        } else {
            if (response.status === "Success") {
                let url = response.data.appUrl + "/" + (dataItem.defaultPortal && dataItem.defaultPortal.id ? dataItem.defaultPortal.urlName : "");
                window.open(url, "_blank").focus();
            }
            return { status: "Success" };
        }
    };

    const publishJsonToRuntime = async (compressedJson, instance) => {
        console.time("Runtime");
        let result = await publishApplication(msalContext, instance, compressedJson, true);
        console.timeEnd("Runtime");
        return result;
    };


    if (!error.isValid) {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
                <div className="alert alert-danger" role="alert">
                    {error.message}
                </div>
            </div>
        );
    }

    if (appStatus === "Upgrade") {
        return (
            <div className="d-flex justify-content-center align-items-center m-auto h-75">
                <UpgardeContent
                    onBack={onCancel}
                    showBackButton={true}
                    Type={'Pro'}
                />
            </div>
        );
    }
    if (appStatus === "Success") {
        return (
            <SuccessfulPublishContent
                isShowFromWorkspace={true}
                onBack={onCancel}
            />
        );
    }

    if (appStatus === "Failure") {
        return (
            <FailurePublishContent
                isShowFromWorkspace={false}
                title={"Opps. There is something wrong happened. Please try again."}
                onClose={onCancel}
            />
        );
    }

    return (
        <InProgressPublishContent messages={messages.publish} />
    );
};

export default PublishingAppToWorkspace;